import React from "react";
import { ResponsiveContainer, RadialBarChart, RadialBar, PolarAngleAxis } from "recharts";
import styled from "../style.module.css";
import { COPPER } from "./theme";

// Single-value radial gauge (0–max). Good for rates/percentages.
const RadialGauge = ({ title, value, max = 100, suffix = "%", color = COPPER, caption, asOf = true }) => {
  const v = Number(value) || 0;
  const data = [{ name: title, value: Math.min(v, max) }];

  return (
    <div className={styled.chartCard}>
      <div className={styled.chartCardHead}>
        <h3 className={styled.chartTitle}>{title}</h3>
        {asOf && <span className={styled.asOfTag}>Live</span>}
      </div>
      <div className={styled.gaugeWrap}>
        <ResponsiveContainer width="100%" height={180} minWidth={0}>
          <RadialBarChart
            innerRadius="72%"
            outerRadius="100%"
            data={data}
            startAngle={90}
            endAngle={-270}
          >
            <PolarAngleAxis type="number" domain={[0, max]} tick={false} />
            <RadialBar background={{ fill: "rgba(255,255,255,0.07)" }} dataKey="value" cornerRadius={10} fill={color} />
          </RadialBarChart>
        </ResponsiveContainer>
        <div className={styled.gaugeCenter}>
          <span className={styled.gaugeValue}>
            {v}
            <span className={styled.gaugeSuffix}>{suffix}</span>
          </span>
          {caption && <span className={styled.gaugeCaption}>{caption}</span>}
        </div>
      </div>
    </div>
  );
};

export default RadialGauge;
